import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { cookiesKeys } from '@/app/constants/cookiesKeys';
import { getAfterAuthRoute } from '@/app/utils/auth/getAfterAuthRoute';
import { decode } from '@/app/utils/auth/jwt';
import { getAuthRedirectUri, redirectToAuth } from '@/app/utils/auth/redirect';
import { converters } from '@/app/utils/converters';
import { LaunchScreen } from '@/common/components/modules/launch-screen';
import { secureStorage } from '@/infra/protocols/storage';
import { authService } from '@/modules/auth/services';

export const Route = createFileRoute('/_auth/auth')({
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  component: () => <LaunchScreen isLoading />,
  beforeLoad: ({ context, search }) => {
    if (context.auth.signedIn) {
      throw redirect({ to: search.redirect ?? getAfterAuthRoute() });
    }

    const routeSearchParams = new URLSearchParams(location.search);

    if (!routeSearchParams.get('code')) {
      redirectToAuth();

      return;
    }

    authService
      .getAccessToken({
        code: routeSearchParams.get('code') ?? '',
        requestUri: getAuthRedirectUri(),
      })
      .then((response) => {
        const isToRemember = secureStorage.get(cookiesKeys.REMEMBER_EMAIL);

        if (isToRemember && converters.boolean(isToRemember)) {
          const email = decode(response.accessToken)?.email ?? 'false';
          secureStorage.add(cookiesKeys.REMEMBER_EMAIL, email);
        }

        return response;
      })
      .then(({ accessToken, refreshToken }) => context.auth.signin(accessToken, refreshToken));
  },
});
